export default __webpack_public_path__ + "static/media/3.b08c8e9a.svg";